<div class="loading" *ngIf="toggleLoading">
  <app-loading *ngIf="toggleLoading"></app-loading>
</div>

<section class="compare" *ngIf="!toggleLoading">
  <div class="container">
    <table class="compare-table" *ngIf="products?.length">
      <tbody class="compare__list" *ngFor="let product of products; let i = index; let first = first"
        [class.first-tbody]="first">
        <tr class="compare__list__row">
          <td class="compare__list__label" *ngIf="i === 0">
            {{ 'compare.product' | translate }}
          </td>
          <td class="compare__list__cell image-container">
            <!-- [queryParams]="{ variant: product?.id }" -->
            <a [routerLink]="['/' + lang + '/' + product?.slug]" >
              <img  loading="lazy"  [src]="product.image"    alt="{{ product.name }}" class="compare__list__image" />
            </a>
          </td>
        </tr>
        <tr class="compare__list__row">
          <td class="compare__list__label" *ngIf="i === 0">
            {{ 'compare.name' | translate }}
          </td>
          <td class="compare__list__cell">
            <!-- [queryParams]="{ variant: product?.id }" -->
            <a [routerLink]="['/' + lang + '/' + product?.slug]" >
              <h2 class="compare__list__content compare__list__content--name product-name">
                {{ product.name }}
              </h2>
            </a>
          </td>
        </tr>
        <tr class="compare__list__row">
          <td class="compare__list__label" *ngIf="i === 0">
            {{ 'compare.price' | translate }}
          </td>
          <td class="compare__list__cell">
            <h2 class="compare__list__content compare__list__content__price_container">
              <ng-container *ngIf="product?.price && environmentVariables?.GUEST_CAN_VIEW_PRICES">
                <span 
                style="font-size: 13px !important;"
                class="compare__list__content compare__list__content__price defult-price-color"
                  [ngClass]="{'config-price-after-discount' : product?.discount_price &&  environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR ,
                  'config-price-color' : environmentVariables?.PRODUCT_PRICE_TEXT_COLOR , 
                  'defult-price-color-after-discount':!environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR && product?.discount_price 
                  
            }"
                  >
                  {{ product.price | number }}
                  {{
                    lang == 'en'
                      ? environmentVariables?.CURRENCY_CODE_EN
                      : environmentVariables?.CURRENCY_CODE_AR
                  }}
                </span>
                <span class="compare__list__content compare__list__content__price payment_with_discount_container defult-price-color"
                  *ngIf="product?.discount_price && environmentVariables?.GUEST_CAN_VIEW_PRICES"
                  [ngClass]="{'config-price-before-discount' : product?.discount_price && environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR 
                }"
                  >
                  {{ product.discount_price | number }}
                  {{
                    lang == 'en'
                      ? environmentVariables?.CURRENCY_CODE_EN
                      : environmentVariables?.CURRENCY_CODE_AR
                  }}
                  <div class="discount-method-information grid-view" *ngIf="product?.payment_methods_discount_name_en">
                    <p>i</p>
                    <div class="hover-info">
                      {{
                        lang == 'en'
                          ? product?.payment_methods_discount_name_en
                          : product?.payment_methods_discount_name_ar
                      }}
                    </div>
                  </div>
                </span>
              </ng-container>
            </h2>
          </td>
        </tr>
        <tr class="compare__list__row">
          <td class="compare__list__label" *ngIf="i === 0">
            {{ 'compare.availability' | translate }}
          </td>
          <td class="compare__list__cell d-inline-flex justify-center align-items-center flex-warp">
            <app-cart-stock-validation-errors [product]="product"></app-cart-stock-validation-errors>

            <ng-container *ngIf="product?.active">
              <h2 class="compare__list__content compare__list__content stock state-label available-state-label"
                *ngIf="product?.in_stock">
                {{ 'compare.inStock' | translate }}
              </h2>
            </ng-container>
          </td>
        </tr>

        <tr class="compare__list__row">
          <td class="compare__list__label" *ngIf="i === 0">
            {{ 'productDetails.description' | translate }}
          </td>
          <td class="compare__list__cell compare__list__cell--description">
            <h2 class="compare__list__content compare__list__content--text" [innerHtml]="product.description"></h2>
          </td>
        </tr>
        <tr *ngFor="let spec of specification" class="compare__list__row">
          <td class="compare__list__label" *ngIf="i === 0">{{ spec }}</td>
          <td class="compare__list__content d-block" style="text-align: left"
            [innerHtml]="getAttributeValue(product.details.attributes, spec)"></td>
        </tr>
        <ng-container *ngIf="environmentVariables?.SHOW_PRODUCT_VARIANTS_OPTIONS">
          <tr *ngFor="let options of product?.product_variants_options" class="compare__list__row">
            <td class="compare__list__label" *ngIf="i === 0">
              {{ options?.option?.name }}
            </td>
            <td class="compare__list__content" style="text-align: center; font-size: 18px">
              {{ options?.values[0]?.name }}
            </td>
          </tr>
        </ng-container>

        <mat-icon (click)="!product['loading'] ? removeProduct(product, i) : null"
          class="fa fa-window-close compare__remove-product"></mat-icon>
        <app-loading *ngIf="product['loading']"> </app-loading>
        <tr class="add-to-cart-button">
					<button mat-raised-button class="blueButton w-150px px-2"
            (click)="redirectToProductFun(product)"
            style="outline: none !important ; height: 36px" >
            <span>
              {{'productDetails.viewDetails' | translate}}
            </span>  
				  </button>
        </tr>
      </tbody>
    </table>
    <ng-container *ngIf="!products?.length && !toggleLoading">
      <div class="section-gap-lg text-center cartEmpty">
        <div class="mb-4">
          <mat-icon class="material-icons compare-icon"> compare </mat-icon>
        </div>
        <h4>{{ 'compare.compareListIsEmpty' | translate }}</h4>
        <a href="javascript:void(0)" class="primary-color" [routerLink]="['/' + lang + '/']">
          {{ 'cart.goForShopping' | translate }}
        </a>
      </div>
    </ng-container>
  </div>
</section>
